module.exports = __webpack_public_path__ + "img/gPay-Sms.1835c9bd.svg";